import { render } from "./clear-modal.vue?vue&type=template&id=118bbe0f"
import script from "./clear-modal.vue?vue&type=script&lang=js"
export * from "./clear-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__